/* eslint-disable */
import {
  DollarOutlined,
  FileTextOutlined,
  LoadingOutlined,
  ZoomOutOutlined,
  FieldNumberOutlined
} from '@ant-design/icons'
import { Button, Card, Col, DatePicker, Form, Input, Row, Spin, Table, Tabs, Tag, message } from 'antd';
import type { ColumnsType, SorterResult } from 'antd/es/table/interface';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import InstitutionUserService from '../../services/InstitutionUserService';
import { parseMoneyAmount } from '../../utils/parseMoneyAmount';
import { RefundStatsRangeAlert } from './RefundStatsRangeAlert';
import moment from 'moment'
import DynamicTable from '../common/DynamicTable'
import styles from '../../asserts/css/BiddersRefundRequestStatus.module.css';

const antIcon = <LoadingOutlined style={{ fontSize: 'var(--base-font-size)', color: '#37762F' }} spin />
const { RangePicker } = DatePicker

interface PaymentsMeta {
  total: number
  pageSize: number
  currentPage: number
}
interface DataType {
  index: any;
  key: React.Key
  bank_code: string
  transaction_reference: string
  debit_account_number: string
  debit_account_name: string
  beneficiary_account_name: string
  beneficiary_bank_name: string
  beneficiary_account_number: string
  transaction_currency: string
  amount: number
  reason: string
  status: string
  created_at: string;
  updated_at: string;
  totalPayments: string;
  amountRequestedToBeRefund: string;
  amountRequestedToBeRefundedInProgressStatus: string;
  TotalNumberOfApplicantRequestedRefund: string;
  notRequestedBidders: string;
}
const BiddersRefundRequestStatus: React.FC = () => {
  const [form] = Form.useForm()
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const navigate = useNavigate()
  const [filterStatus, setfilterStatus] = useState('')
  const [clear, setClear] = useState(false)
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [refundRequestList, setRefundRequestList] = useState<DataType[]>([]);
  const [loading, setLoading] = useState(false);
  const [progressVisible, setProgressVisible] = useState(false); // State for progress bar visibility
  const [progressPercent, setProgressPercent] = useState(0); // State for progress percentage
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({})
  const [token, setToken] = useState(() => {
    try {
      const u = JSON.parse(localStorage.getItem('userInfo') ?? '{}') as { token?: string }
      return typeof u?.token === 'string' ? u.token : ''
    } catch {
      return ''
    }
  })
  const [paymentsMeta, setPaymentsMeta] = useState<PaymentsMeta | null>(null)
  const [BiddersAmountRequestedToBeRefund, setBiddersAmountRequestedToBeRefund] = useState('')
  const [BailiffAmountRequestedToBeRefunded, setBailiffAmountRequestedToBeRefunded] = useState('')
  const [NewBiddersAmountRequestedToBeRefunded, setNewBiddersAmountRequestedToBeRefunded] = useState('')
  const [NewBailiffAmountRequestedToBeRefunded, setNewBailiffAmountRequestedToBeRefunded] = useState('')
  const [totalRefundedAmount, setTotalRefundedAmount] = useState(0)
  const [remainingToRequest, setRemainingToRequest] = useState<number | null>(null)
  const [totalPaidForRange, setTotalPaidForRange] = useState('')

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [stats, setStats] = React.useState<DataType | null>(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [activeTab, setActiveTab] = useState('bidders'); // Default tab
  const [bailiffRefundRequestList, setBailiffRefundRequestList] = useState<DataType[]>([]);

  useEffect(() => {
    handlePageReload();
  }, []);

  useEffect(() => {
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      async function fetchRefundStats () {
        setLoading(true)
        try {
          const response = await InstitutionUserService.viewRefundStatsByRefundStartDate(fromDate, toDate, token)
          setBiddersAmountRequestedToBeRefund(response.data?.biddersAmountRequestedToBeRefund)
          setBailiffAmountRequestedToBeRefunded(response.data?.bailiffAmountRequestedToBeRefunded)
          setNewBiddersAmountRequestedToBeRefunded(response.data?.newBiddersAmountRequestedToBeRefunded)
          setNewBailiffAmountRequestedToBeRefunded(response.data?.newBailiffAmountRequestedToBeRefunded)
          const tr = parseMoneyAmount(response.data?.totalRefundedAmount)
          setTotalRefundedAmount(tr)
          const rem =
            response.data?.remainingToRequest ?? response.data?.remaining
          if (rem !== undefined && rem !== null) {
            const n = parseMoneyAmount(rem)
            setRemainingToRequest(Number.isFinite(n) ? n : null)
          } else {
            setRemainingToRequest(null)
          }
          const tp = response.data?.totalPayments
          setTotalPaidForRange(tp != null && tp !== '' ? String(tp) : '')
        } catch (err) {
          void message.error('Failed to fetch refund stats')
          // eslint-disable-next-line no-console
          console.error(err)
        } finally {
          setLoading(false)
        }
      }

      void fetchRefundStats()
    },
    [fromDate, toDate, token])

  useEffect(() => {
    OnRefundRequestSearch();
  }, []);

  const handlePageReload = () => {
    setProgressVisible(true);
    setLoading(true);

    // Simulating data fetching delay
    setTimeout(() => {
      setLoading(false);
      setProgressVisible(false);
    }, 5000);
  };
  useEffect(() => {
    if (activeTab === 'bidders') {
      const total = refundRequestList.reduce((acc, curr) => acc + curr.amount, 0);
      setTotalAmount(total);
    } else if (activeTab === 'bailiffs') {
      const total = bailiffRefundRequestList.reduce((acc, curr) => acc + curr.amount, 0);
      setTotalAmount(total);
    }
  }, [refundRequestList, bailiffRefundRequestList, activeTab]);

  React.useEffect(() => {
    InstitutionUserService.RefundRequestStats()
      .then((res: any) => {
        setStats(res.data);
      })
      .catch((err) => {
        message.error(err?.message);
      });
  }, []);

  // const handleChange: TableProps<DataType>['onChange'] = (pagination, _filters, sorter) => {
  //   setPagination(pagination)
  //   setSortedInfo(sorter as SorterResult<DataType>)
  // }
  const handleTableChange = (pagination: any) => {
    setPagination(pagination) // Update pagination state on page change
  }

  // Handle view details action for DynamicTable
  const handleViewDetails = (record: DataType) => {
    navigate('/view-refund-request', { state: record })
  }

  let filter = ''
  if (filterStatus) {
    filter = filter + 'Type'
  }
  if (fromDate) {
    filter = filter === '' ? filter + 'From Date' : filter + ', From Date'
  }
  if (toDate) {
    filter = filter === '' ? filter + 'To Date' : filter + ', To Date'
  }
  const convertToExcel = (data: any[], maxColumns: number = 10): XLSX.WorkBook => {
    // your function logic...
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    return wb;
  };
  const handleDownload = () => {
    const selectedColumns = [
      { key: 'beneficiary_account_name', header: 'Beneficiary Name' },
      { key: 'amount', header: 'Amount (RWF)' },
      { key: 'beneficiary_bank_name', header: 'Bank Name' },
      { key: 'beneficiary_account_number', header: 'Account Number' },
      { key: 'updated_at', header: 'Last Updated' }
    ];

    const dataSource = activeTab === 'bidders' ? refundRequestList : bailiffRefundRequestList;

    const filteredData = dataSource.filter(item => {
      const date = moment(item.created_at);
      return date.isSameOrAfter(fromDate) && date.isSameOrBefore(toDate);
    });

    const dataToDownload = filteredData.map(item => {
      const formattedRow: Record<string, any> = {};
      selectedColumns.forEach(({ key, header }) => {
        // @ts-ignore
        formattedRow[header] = item[key];
      });
      return formattedRow;
    });

    // Title row
    const reportTitle = `Refund Requests Report (${activeTab.toUpperCase()}) - ${moment().format('MMMM Do YYYY')}`;
    const titleRow = { [selectedColumns[0].header]: reportTitle };
    const blankRow = {};

    const headersRow = selectedColumns.reduce((acc, col) => {
      acc[col.header] = col.header;
      return acc;
    }, {} as Record<string, string>);

    // Combine title, blank row, and actual data
    const finalData = [titleRow, blankRow, headersRow, ...dataToDownload];

    const worksheet = XLSX.utils.json_to_sheet(finalData, { skipHeader: false });

    // Merge title across columns
    worksheet['!merges'] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: selectedColumns.length - 1 }
      }
    ];

    // Style title row
    const titleCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    worksheet[titleCell].s = {
      font: {
        bold: true,
        sz: 14,
        color: { rgb: 'FFFFFF' }
      },
      alignment: {
        horizontal: 'center'
      },
      fill: {
        fgColor: { rgb: '37762F' } // Dark green background
      }
    };

    // Optional: style header row (row 2 — after blank row)
    const headerStyle = {
      font: {
        bold: true,
        color: { rgb: 'FFFFFF' }
      },
      alignment: {
        horizontal: 'center'
      },
      fill: {
        fgColor: { rgb: '33bbff' } // Light blue background
      }
    };

    selectedColumns.forEach((col, i) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c: i }); // Row index 2 due to title and blank row
      if (worksheet[cell]) {
        worksheet[cell].s = headerStyle;
      }
    });

    // Auto-size columns
    const columnWidths = selectedColumns.map(({ header }) => {
      const maxLength = Math.max(
        header.length,
        ...dataToDownload.map(row => String(row[header] || '').length)
      );
      return { wch: maxLength + 4 };
    });
    worksheet['!cols'] = columnWidths;

    const workbook = XLSX.utils.book_new();
    const sheetName = activeTab === 'bidders' ? 'Bidders' : 'Bailiffs';
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const filename = `refund_${activeTab}_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
    XLSX.writeFile(workbook, filename);

    console.log(`✅ Excel file "${filename}" successfully generated.`);
  };

  // Downloads the Excel file
  const downloadExcel = (wb: XLSX.WorkBook, fileName: string) => {
    console.log('Preparing to download Excel file...');

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    if ((navigator as any).msSaveBlob) { // For IE 10+
      (navigator as any).msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('File download not supported on this browser.');
      }
    }

    console.log('Excel file downloaded.');
  };

  // Handle the process of downloading the Excel file
  const handleDownloadExcelFile = async (): Promise<void> => {
    try {
      console.log('Handling download of Excel file...');

      let dataToDownload: { [x: string]: any }[] = [];
      if (activeTab === 'bidders') {
        dataToDownload = refundRequestList;
      } else if (activeTab === 'bailiffs') {
        dataToDownload = bailiffRefundRequestList;
      }

      console.log('Data to download:', dataToDownload);

      const wb = convertToExcel(dataToDownload, 10);
      downloadExcel(wb, 'Refund Request Report.xlsx');
    } catch (error) {
      console.error('Error occurred while downloading Excel:', error);
      message.warning("Error occurred while downloading Excel and updating refund request status.");
    }
  };

  const clearFilter = (): void => {
    setfilterStatus('')
    form.setFieldValue('filterStatus', '')
    form.setFieldValue('range_picker', ['', ''])
    setFromDate('')
    setToDate('')
    setClear(true)
  }

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  useEffect(() => {
    OnRefundRequestSearch();
  }, [activeTab, pagination.pageSize, pagination.current, filterStatus, fromDate, toDate]);

  const OnRefundRequestSearch = (event?: any): void => {
    setLoading(true);
    const service = activeTab === 'bidders' ? InstitutionUserService.GetRefundRequestListByStatus : InstitutionUserService.GetBailiffRefundRequestListByStatus;
    service(
      pagination.pageSize as number,
      pagination.current as number,
      event?.target?.value,
      fromDate,
      toDate
    )
      .then((res: any) => {
        if (res.status === 200) {
          if (activeTab === 'bidders') {
            setRefundRequestList(res?.data);
            setPaymentsMeta(res?.meta)
          } else if (activeTab === 'bailiffs') {
            setBailiffRefundRequestList(res?.data);
            setPaymentsMeta(res?.meta)
          }
          setPagination((prev) => ({
            ...prev,
            total: res?.meta?.total
          }));
          setLoading(false);
        }
      })
      .catch((err: any) => {
        if (err?.message !== 'Operation canceled due to new request.') {
          message.error(err?.message);
        }
        setLoading(false);
      });
  };
  const bailiffsColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 90,
      render: (text, record, index) => {
        const pageNumber = pagination.current || 1
        const pageSize = pagination.pageSize || 10
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>;
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false,
      responsive: ['md'],
    },
    {
      title: 'Transaction Reference',
      dataIndex: 'transaction_reference',
      key: 'transaction_reference',
      sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
      sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Debit Account Name',
      dataIndex: 'debit_account_name',
      key: 'debit_account_name',
      sorter: (a: any, b: any) => a.debit_account_name.localeCompare(b.debit_account_name),
      sortOrder: sortedInfo?.columnKey === 'debit_account_name' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Beneficiary Account Name',
      dataIndex: 'beneficiary_account_name',
      key: 'beneficiary_account_name',
      sorter: (a: any, b: any) => a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Beneficiary Bank Name',
      dataIndex: 'beneficiary_bank_name',
      key: 'beneficiary_bank_name',
      sorter: (a: any, b: any) => a?.beneficiary_bank_name.localeCompare(b?.beneficiary_bank_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_bank_name' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Beneficiary Account Number',
      dataIndex: 'beneficiary_account_number',
      key: 'beneficiary_account_number',
      sorter: (a: any, b: any) => a?.beneficiary_account_number.localeCompare(b?.beneficiary_account_number),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_number' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (_text: any, record: any) => {
        const amount = parseInt(String(record?.amount ?? '0'), 10) || 0;
        return <span style={{ color: 'var(--refund-theme-primary)', fontWeight: 'bold' }}>{amount.toLocaleString()} Rwf</span>;
      },
      sorter: (a: any, b: any) => Number(a?.amount ?? 0) - Number(b?.amount ?? 0),
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Transaction Currency',
      dataIndex: 'transaction_currency',
      key: 'transaction_currency',
      sorter: (a: any, b: any) => a.transaction_currency.localeCompare(b.transaction_currency),
      sortOrder: sortedInfo?.columnKey === 'transaction_currency' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (text: any, record: any) => {
        const status = String(record?.status ?? text ?? '').trim();
        let displayStatus = status;
        let color = 'default';

        if (status === 'PENDING') {
          displayStatus = 'Pending Refund';
          color = 'warning';
        } else if (status === 'INITIATED') {
          displayStatus = 'Initiated Refund';
          color = 'processing';
        } else if (status === 'COMPLETED' || status === 'APPROVED' || status === 'Downloaded to be Refunded') {
          displayStatus = 'Completed Refund';
          color = 'success';
        } else if (status === 'RECEIVED REQUEST') {
          displayStatus = 'Received Request';
          color = 'processing';
        } else if (status === 'REJECTED') {
          displayStatus = 'Rejected';
          color = 'error';
        }

        return (
          <Tag color={color} style={{ borderRadius: 999, padding: '2px 10px', fontWeight: 600 }}>
            {displayStatus || '-'}
          </Tag>
        );
      },
      key: 'status',
      width: 200,
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      sortOrder: sortedInfo?.columnKey === 'status' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text: any, record: any) => (
        <div className="w-[60%] flex justify-center icon-container">
          <i
            className="far fa-eye cursor-pointer icon-style"
            onClick={() => {
              navigate('/view-refund-request', { state: record })
            }}
          ></i>
        </div>
      )
    }
  ];
  const biddersColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 90,
      render: (text, record, index) => {
        const pageNumber = pagination.current || 1
        const pageSize = pagination.pageSize || 10
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>;
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false,
      responsive: ['md'],
    },
    {
      title: 'Transaction Reference',
      dataIndex: 'transaction_reference',
      key: 'transaction_reference',
      sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
      sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Debit Account Name',
      dataIndex: 'debit_account_name',
      key: 'debit_account_name',
      sorter: (a: any, b: any) => a.debit_account_name.localeCompare(b.debit_account_name),
      sortOrder: sortedInfo?.columnKey === 'debit_account_name' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Beneficiary Account Name',
      dataIndex: 'beneficiary_account_name',
      key: 'beneficiary_account_name',
      sorter: (a: any, b: any) => a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Beneficiary Bank Name',
      dataIndex: 'beneficiary_bank_name',
      key: 'beneficiary_bank_name',
      sorter: (a: any, b: any) => a?.beneficiary_bank_name.localeCompare(b?.beneficiary_bank_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_bank_name' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Beneficiary Account Number',
      dataIndex: 'beneficiary_account_number',
      key: 'beneficiary_account_number',
      sorter: (a: any, b: any) => a?.beneficiary_account_number.localeCompare(b?.beneficiary_account_number),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_number' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (_text: any, record: any) => {
        const amount = parseInt(String(record?.amount ?? '0'), 10) || 0;
        return <span style={{ color: 'var(--refund-theme-primary)', fontWeight: 'bold' }}>{amount.toLocaleString()} Rwf</span>;
      },
      sorter: (a: any, b: any) => Number(a?.amount ?? 0) - Number(b?.amount ?? 0),
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Transaction Currency',
      dataIndex: 'transaction_currency',
      key: 'transaction_currency',
      sorter: (a: any, b: any) => a.transaction_currency.localeCompare(b.transaction_currency),
      sortOrder: sortedInfo?.columnKey === 'transaction_currency' ? sortedInfo?.order : null,
      ellipsis: true,
      responsive: ['md'],
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (text: any, record: any) => {
        const status = String(record?.status ?? text ?? '').trim();
        let displayStatus = status;
        let color = 'default';

        if (status === 'PENDING') {
          displayStatus = 'Pending Refund';
          color = 'warning';
        } else if (status === 'INITIATED') {
          displayStatus = 'Initiated Refund';
          color = 'processing';
        } else if (status === 'COMPLETED' || status === 'APPROVED' || status === 'Downloaded to be Refunded') {
          displayStatus = 'Completed Refund';
          color = 'success';
        } else if (status === 'RECEIVED REQUEST') {
          displayStatus = 'Received Request';
          color = 'processing';
        } else if (status === 'REJECTED') {
          displayStatus = 'Rejected';
          color = 'error';
        }

        return (
          <Tag color={color} style={{ borderRadius: 999, padding: '2px 10px', fontWeight: 600 }}>
            {displayStatus || '-'}
          </Tag>
        );
      },
      key: 'status',
      width: 200,
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      sortOrder: sortedInfo?.columnKey === 'status' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text: any, record: any) => (
        <div className="w-[60%] flex justify-center icon-container">
          <i
            className="far fa-eye cursor-pointer icon-style"
            onClick={() => {
              navigate('/view-refund-request', { state: record })
            }}
          ></i>
        </div>
      )
    }
  ]

  return (
    <div className="w-full">
      {/* Enhanced Custom CSS Styles - Matching UsersAccountsTable */}
      <style>{`
        .enhanced-card {
          background: linear-gradient(135deg, var(--refund-theme-bg) 0%, var(--refund-theme-bg-soft) 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-table-row:nth-child(even) {
          background-color: var(--refund-theme-bg);
        }
        .enhanced-table-row:hover {
          background-color: var(--refund-theme-bg-soft);
        }
        .enhanced-table-header {
          background: linear-gradient(135deg, var(--refund-theme-primary) 0%, #4a7c59 100%);
          color: white;
          font-weight: 600;
        }
        .ant-table-thead > tr > th {
          background: none !important;
          border-bottom: 2px solid #cbd5e1 !important;
          font-weight: 600 !important;
          color: #374151 !important;
        }
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid #e5e7eb !important;
        }
        /* Enhanced Tab Styling */
        .ant-tabs-card > .ant-tabs-content {
          margin-top: 0;
        }
        .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
          background: transparent;
          padding: 0;
        }
        .ant-tabs-card .ant-tabs-tab {
          background: var(--refund-theme-bg) !important;
          border: 2px solid #e5e7eb !important;
          border-radius: 8px 8px 0 0 !important;
          margin-right: 8px !important;
          padding: 12px 24px !important;
          font-weight: 600 !important;
          font-size: 15px !important;
          color: #6b7280 !important;
          transition: all 0.3s ease !important;
        }
        .ant-tabs-card .ant-tabs-tab:hover {
          background: var(--refund-theme-bg-soft) !important;
          border-color: #cbd5e1 !important;
          color: #374151 !important;
          transform: translateY(-2px);
        }
        .ant-tabs-card .ant-tabs-tab-active {
          background: linear-gradient(135deg, var(--refund-theme-primary) 0%, #4a7c59 100%) !important;
          border-color: var(--refund-theme-primary) !important;
          color: white !important;
          box-shadow: 0 4px 12px rgba(55, 118, 47, 0.3) !important;
        }
        .ant-tabs-card .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: white !important;
        }
        .ant-tabs-nav {
          margin-bottom: 20px !important;
          padding: 0 4px !important;
        }
        .ant-tabs-tab-btn {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
        }
      `}</style>

      <div className="px-5 py-4 border-b-slate-200 border border-solid w-full" style={{
        background: 'linear-gradient(135deg, var(--refund-theme-bg) 0%, var(--refund-theme-bg-soft) 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px',
      }}>
        <div className="flex justify-between items-center">
          <div className="text-title font-bold flex items-center">
            <div style={{
              background: 'linear-gradient(135deg, var(--refund-theme-primary) 0%, #4a7c59 100%)',
              borderRadius: '50%',
              width: '48px',
              height: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '16px',
              boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)',
            }}>
              <span style={{ fontSize: '24px' }}>📋</span>
            </div>
            <div>
              <h2 className="text-title font-bold" style={{
                margin: 0,
                background: 'linear-gradient(135deg, var(--refund-theme-primary) 0%, #4a7c59 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}>
                Refund Request Status
              </h2>
              <p style={{
                margin: '4px 0 0 0',
                fontSize: '14px',
                color: '#6b7280',
                fontWeight: '500',
              }}>
                💳 Transfer to Internet Banking • Status Tracking Dashboard
              </p>
            </div>
          </div>
          <div className="md:w-1/5"></div>
        </div>
      </div>
      <RefundStatsRangeAlert fromDate={fromDate} toDate={toDate} />
      {/* Enhanced stats section with hover effects - Responsive */}
      <div style={{
        padding: '20px',
        backgroundColor: 'var(--refund-theme-bg)',
        borderRadius: '8px',
        margin: '0 20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}
      className={styles['stats-container']}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Amount Requested
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {((parseMoneyAmount(BailiffAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(BiddersAmountRequestedToBeRefund) ?? 0)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                New Amount Requested
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded) ?? 0)).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Remaining to Request
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {(remainingToRequest !== null
                  ? remainingToRequest
                  : Math.max(
                    0,
                    (parseMoneyAmount(totalPaidForRange) || 0) -
                      ((parseMoneyAmount(BiddersAmountRequestedToBeRefund) || 0) +
                        (parseMoneyAmount(BailiffAmountRequestedToBeRefunded) || 0))
                  )
                ).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Total Paid Amount
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {(parseMoneyAmount(totalPaidForRange) || 0).toLocaleString()} Rwf
              </div>
            </div>
          </Col>

          <Col xs={24} sm={12} md={8} lg={4} xl={4} xxl={4}>
            <div
              className="stat-card"
              style={{
                width: '100%',
                background: 'var(--refund-theme-bg)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid var(--refund-theme-border)',
                textAlign: 'center',
                color: '#111827',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'default',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
              }}
            >
              <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                Refunded Amount
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--refund-theme-primary)' }}>
                {totalRefundedAmount.toLocaleString()} Rwf
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="px-2">
        <div className="py-0 mb-0">
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form p-10"
            initialValues={{ remember: true }}
            form={form}
          >
            <Card
              className="bg-gradient-to-r from-blue-50 to-indigo-50"
              style={{
                borderRadius: '12px',
                border: '1px solid #e0e7ff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
              }}
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} xl={18}>
                  <Form.Item
                    name="range_picker"
                    label={<span style={{ fontWeight: '600', color: '#374151' }}>Select Date Range</span>}
                  >
                    <RangePicker
                      size="large"
                      className="w-full"
                      allowClear
                      style={{
                        borderRadius: '8px',
                        border: '2px solid #e5e7eb',
                        transition: 'border-color 0.2s ease',
                      }}
                      onChange={(value, valueString) => {
                        setFromDate(valueString[0])
                        setToDate(valueString[1])
                      }}
                    />
                  </Form.Item>
                  {filter !== ''
                    ? (
                      <div className="flex flex-col md:flex-row justify-between pb-2.5 md:pb-0 gap-2">
                        <div>
                          Applied filters: <span className="font-medium">{filter}</span>
                        </div>
                        <div
                          className="bg-black text-center py-0.5 px-2.5 text-white rounded-sm font-medium cursor-pointer"
                          onClick={clearFilter}
                        >
                          Clear X
                        </div>
                      </div>
                    )
                    : (
                      ''
                    )}
                </Col>
                <Col xs={24} xl={6}>
                  <Form.Item label={<span style={{ color: 'transparent' }}>Action</span>}>
                    <Button
                      type="primary"
                      size="large"
                      className="w-full font-bold"
                      disabled={fromDate.length === 0 || toDate.length === 0}
                      onClick={handleDownload}
                      style={{
                        background: fromDate.length === 0 || toDate.length === 0
                          ? '#d1d5db'
                          : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        height: '48px',
                        fontSize: '16px',
                        fontWeight: '600',
                        boxShadow: fromDate.length === 0 || toDate.length === 0
                          ? 'none'
                          : '0 4px 12px rgba(16, 185, 129, 0.3)',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        if (fromDate.length > 0 && toDate.length > 0) {
                          e.currentTarget.style.transform = 'translateY(-1px)';
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (fromDate.length > 0 && toDate.length > 0) {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
                        }
                      }}
                    >
                      📊 FILTER & DOWNLOAD
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Form>
        </div>
        <Card
          style={{
            marginTop: '8px',
            borderRadius: '16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            border: '1px solid #e5e7eb',
            overflow: 'hidden'
          }}
        >
          <div style={{
            background: 'var(--refund-theme-primary-soft)',
            color: '#000000',
            fontWeight: 'normal',
            padding: '16px 20px',
            margin: '-24px -24px 24px -24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="fas fa-users" style={{ fontSize: '24px' }}></i>
              <span style={{ fontSize: '18px', fontWeight: 'normal' }}>
                {activeTab === 'bidders'
                  ? `All Bidders (${refundRequestList.length})`
                  : `All Bailiffs (${bailiffRefundRequestList.length})`
                }
              </span>
            </div>
          </div>

          <Tabs
            onChange={(key) => handleTabChange(key)}
            type="card"
              size="large"
            defaultActiveKey="bidders"
            activeKey={activeTab}
            tabBarExtraContent={
              <div className="w-full flex flex-col md:flex-row md:items-center md:space-x-4 space-y-2 md:space-y-0">
            <Button
              onClick={handleDownloadExcelFile}
              style={{
                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                fontWeight: '600',
                height: '40px',
                padding: '0 16px',
                boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(59, 130, 246, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.3)';
              }}
            >
              📊 Download Report
            </Button>
                <Button type="link" className="md:ml-2 w-full md:w-auto" onClick={clearFilter}>
                  Clear Filter
            </Button>
          </div>
            }
              items={[
                {
                  key: 'bidders',
                  label: (
                  <span style={{ display: 'flex', alignItems: 'center', fontWeight: '600' }}>
                    Bidders
                    </span>
                  ),
                  children: (
                  <div>
                    <div style={{ marginBottom: '20px' }}>
                      <Input
                        size="large"
                        placeholder="Search by transaction reference, beneficiary name, or account number..."
                        prefix={<ZoomOutOutlined style={{ color: '#667eea', fontSize: '18px' }} />}
                        onChange={OnRefundRequestSearch}
                        style={{
                          borderRadius: '10px',
                          border: '2px solid #e5e7eb',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                        }}
                      />
                    </div>

                    <div style={{ overflowX: 'auto' }}>
                      {loading
                        ? (
                          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
                            <div style={{ color: '#9ca3af', fontSize: '16px' }}>Loading refund requests...</div>
                          </div>
                          )
                        : (
                      <DynamicTable
                        data={refundRequestList}
                        useCustomColumns={true}
                        customColumnsConfig={biddersColumns}
                        onChange={handleTableChange}
                        pagination={{
                          ...pagination,
                              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                          showSizeChanger: true,
                          showQuickJumper: true,
                              hideOnSinglePage: false,
                              pageSizeOptions: ['10', '20', '50', '100'],
                              showLessItems: true,
                          style: {
                                background: '#F5F5F5',
                                borderRadius: '8px',
                                padding: '12px',
                                border: '1px solid #e5e7eb',
                                marginTop: '16px'
                              }
                        }}
                        onViewDetails={handleViewDetails}
                        scroll={{ x: 600 }}
                            rowClassName={(record, index) => index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                      />
                          )}
                    </div>
                  </div>
                  )
                },
                {
                  key: 'bailiffs',
                  label: (
                  <span style={{ display: 'flex', alignItems: 'center', fontWeight: '600' }}>
                    Bailiffs
                    </span>
                  ),
                  children: (
                  <div>
                    <div style={{ marginBottom: '20px' }}>
                      <Input
                        size="large"
                        placeholder="Search by transaction reference, beneficiary name, or account number..."
                        prefix={<ZoomOutOutlined style={{ color: '#667eea', fontSize: '18px' }} />}
                        onChange={OnRefundRequestSearch}
                        style={{
                          borderRadius: '10px',
                          border: '2px solid #e5e7eb',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                        }}
                      />
                    </div>

                    <div style={{ overflowX: 'auto' }}>
                      {loading
                        ? (
                          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
                            <div style={{ color: '#9ca3af', fontSize: '16px' }}>Loading refund requests...</div>
                          </div>
                          )
                        : (
                      <DynamicTable
                        data={bailiffRefundRequestList}
                        useCustomColumns={true}
                        customColumnsConfig={bailiffsColumns}
                        onChange={handleTableChange}
                        pagination={{
                          ...pagination,
                              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                          showSizeChanger: true,
                          showQuickJumper: true,
                              hideOnSinglePage: false,
                              pageSizeOptions: ['10', '20', '50', '100'],
                              showLessItems: true,
                          style: {
                                background: '#F5F5F5',
                                borderRadius: '8px',
                                padding: '12px',
                                border: '1px solid #e5e7eb',
                                marginTop: '16px'
                              }
                        }}
                        onViewDetails={handleViewDetails}
                        scroll={{ x: 600 }}
                            rowClassName={(record, index) => index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                      />
                          )}
                    </div>
                  </div>
                  )
                }
              ]}
            />
        </Card>
      </div>
    </div>
  );
};

export default BiddersRefundRequestStatus;
